import React from 'react';
import { Row, Col, Alert, Divider } from 'antd';
import { Form, InputNumber } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const UsageRestrictionsSection = ({ isEdit }) => {
  return (
    <>
      <Divider orientation="left">Usage Restrictions</Divider>
      
      <Alert 
        message="Set limits for this license"
        type="info" 
        showIcon 
        icon={<InfoCircleOutlined />} 
        style={{ marginBottom: 16 }}
      />
      
      <Row gutter={24}>
        <Col xs={24} md={12} lg={6}>
          <Form.Item
            label="Max Companies"
            name="max_companies"
            rules={[{ required: true, message: 'Please enter a value' }]}
            extra="Number of companies allowed"
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12} lg={6}>
          <Form.Item
            label="Max Active Employees"
            name="max_employees"
            rules={[{ required: true, message: 'Please enter a value' }]}
            extra="Maximum number of active employees"
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        
        <Col xs={24} md={12} lg={6}>
          <Form.Item
            label="Max Users"
            name="max_users"
            rules={[{ required: true, message: 'Please enter a value' }]}
            extra="Maximum number of users"
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12} lg={6}>
          <Form.Item
            label="Max MAC Address Changes"
            name="max_mac_address_change"
            rules={[{ required: true, message: 'Please enter a value' }]}
            extra="Maximum number of MAC address changes"
          >
            <InputNumber min={0} style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        
      </Row>
    </>
  );
};

export default UsageRestrictionsSection;
